module.exports = __webpack_public_path__ + "static/media/15.ad321b3f.jpg";